module.exports = __webpack_public_path__ + "static/moon.087ae9cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/moon.png
// module id = 678
// module chunks = 114276838955818